import { useTheme } from "../../context/ThemeContext"; // Ajusta la ruta según corresponda

const ApiDocumentation = () => {
  const { isDarkMode } = useTheme(); // Obtener el estado de tema oscuro

  const backgroundColor = isDarkMode ? "#1A202C" : "white"; // Fondo dinámico
  const textColor = isDarkMode ? "white" : "#1A202C"; // Texto dinámico

  // Construir la URL con los parámetros de query
  const swaggerUrl = `https://insights.vooster.io/api-docs?bgColor=${encodeURIComponent(
    backgroundColor
  )}&textColor=${encodeURIComponent(textColor)}`;

  return (
    <div
      className="py-2 h-full flex flex-col"
      style={{
        backgroundColor: backgroundColor, // Fondo dinámico
        color: textColor, // Texto dinámico
      }}
    >
      <div
        className="flex-grow border rounded-md"
        style={{
          backgroundColor: backgroundColor, // Fondo para el contenedor del iframe
        }}
      >
        <iframe
          src={swaggerUrl} // URL con parámetros dinámicos
          title="API Documentation"
          className="w-full h-full border-0"
          style={{
            backgroundColor: backgroundColor, // Fondo dentro del iframe
            color: textColor, // Color de texto dentro del iframe
          }}
        />
      </div>
    </div>
  );
};

export default ApiDocumentation;
